<template>
  <w-modal v-model="open" type="danger">
    <h1 slot="header">確定刪除草稿？</h1>
    <div slot="content" class="content">
      <p>
        <span class="icon-alert-circle" /> 請注意，刪除草稿即無法復原。
      </p>
    </div>
    <div slot="footer">
      <w-button
        type="link"
        color-type="error"
        :disabled="loading"
        @click="open = false"
      >
        返回
      </w-button>
      <w-button
        class="ml-2"
        color-type="error"
        :disabled="loading"
        @click="onDelete"
      >
        {{ loading ? '刪除中⋯' : '確定刪除' }}
      </w-button>
    </div>
  </w-modal>
</template>

<script>
import DraftDeleteConfirmation from './DraftDeleteConfirmation';

export default DraftDeleteConfirmation;
</script>

<style lang="scss" scoped>
@import 'DraftDeleteConfirmation';
</style>
